import * as yup from 'yup'

export const formValidationSchema = yup
  .object({
    code: yup.string().required('Campo obligatorio'),
  })
  .required()
